<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple" [fullScreen]="true">
  <mc-loading-indicator  class="tetsst"  fit="large" label="">
  </mc-loading-indicator>
  <p style="font-size: 20px; color: white">Loading...</p>

</ngx-spinner>

<router-outlet *ngIf="!isIframe"></router-outlet>

<!-- <div color="primary">
  
    <button *ngIf="!loginDisplay">Login</button>
    <div >
      <button  (click)="loginRedirect()">Login using Redirect</button>
      <button  (click)="loginPopup()">Login using Popup</button>
    </div>
  
    <button  *ngIf="loginDisplay">Logout</button>
 
      <button (click)="logout()">Logout using Redirect</button>
      <button (click)="logout(true)">Logout using Popup</button>
  
</div>
  <div class="container">
    <router-outlet *ngIf="!isIframe"></router-outlet>
  </div> -->
